import { Navigate } from 'react-router-dom';

import { LoadingLogo } from '@/components/shared/LoadingLogo';
import { useTenantSwitcher } from '@/contexts/TenantSwitcherContext';

interface TenantsRouteGuardProps {
  children: JSX.Element;
}

export function TenantsRouteGuard({
  children,
}: TenantsRouteGuardProps): JSX.Element {
  const { activeTenant, loadingTenant } = useTenantSwitcher();

  // If loading, show loading state
  if (loadingTenant) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  // If impersonating a tenant, redirect to dashboard
  if (activeTenant) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
